module.exports = function() {
  return new Worker(__webpack_public_path__ + "7594c1eb633d41bfa86f.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/workers/LoadManifestWorker.js
// module id = fJom
// module chunks = 1